import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import useQueryParams from './useQueryParams';

const useLang = () => {
  const { lang: paramsLang } = useQueryParams();
  const prevLocation = useLocation();
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (history) {
      const unlisten = history.listen((currLocation) => {
        const isDifferentRoute =
          prevLocation.search !== currLocation.search ||
          prevLocation.pathname !== currLocation.pathname;
        const hadLangParam = prevLocation.search.includes('lang');
        const hasLangParam = currLocation.search.includes('lang');

        if (hadLangParam && !hasLangParam && isDifferentRoute) {
          const prevSearchParams = new URLSearchParams(prevLocation.search);
          const currSearchParams = new URLSearchParams(currLocation.search);

          const lang = prevSearchParams.get('lang');

          if (lang) {
            currSearchParams.append('lang', lang);
          }

          const stringifiedParams = currSearchParams.toString();
          history.replace(currLocation.pathname + stringifiedParams ? '?' + stringifiedParams : '');
        }
      });

      return () => unlisten();
    }
  }, [history, prevLocation]);

  useEffect(() => {
    if (typeof paramsLang === 'string') {
      i18n.changeLanguage(paramsLang);
    }
  }, [paramsLang, i18n]);
};

export default useLang;
